var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSaveButtonNoBackground(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 21,
    viewBox: "0 0 15 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "save-svgrepo-com 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "vector-grey",
    d: "M2 1L1 2V18.5L7.5 14.5L14 18.5V2L13 1H2Z",
    stroke: "#ACB1B6",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "vector-black",
    d: "M2 1L1 2V18.5L7.5 14.5L14 18.5V2L13 1H2Z",
    stroke: "#212121",
    strokeWidth: 2,
    strokeDasharray: 100,
    strokeDashoffset: 100
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSaveButtonNoBackground);
export default __webpack_public_path__ + "static/media/saveButtonNoBackground.790da92bc0fac44e7c1d277c9a4aa1d9.svg";
export { ForwardRef as ReactComponent };